import { useCallback } from 'react';
import { useAuthContext } from '../internal/AuthContext';
import withGateOverride from '../internal/withGateOverride';
export function useGetIsUngated() {
  const {
    gates
  } = useAuthContext();
  return useCallback(gate => withGateOverride(gate, gates.has(gate)), [gates]);
}